import React, { useState } from "react";
import { useLoaderData } from "react-router-dom";
import "./ImportantDates.css";

const ImportantDates = () => {
  const loadedInfo = useLoaderData();
  const [Dates] = useState(loadedInfo.data[0]);

  const dateItems = [
    {
      value: Dates.PaperSubmissionDeadline,
      label: "Paper Submission Deadline",
    },
    { value: Dates.AcceptanceNotification, label: "Acceptance Notification" },
    { value: Dates.RegistrationDeadline, label: "Registration Deadline" },
    { value: Dates.CameraReadySubmission, label: "Conference Date" },
  ];

  return (
    <section className="date">
      <div className="heading-container">
        <h4>Important Dates</h4>
      </div>
      <div className="container">
        <div className="row g-4 justify-content-center">
          {dateItems.map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-4 col-md-6">
              <div className="date-as-calendar">
                <div className="text-center">
                  <span className="date-label">{item.label}</span>
                  <span className="date-value">{item.value}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImportantDates;
